import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {VoucherDetailModalProps} from "../VoucherInterfaces";
import {useStatusValuesVoucher} from "../../../component/useStatusValuesVoucher";
import {
  UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {formatDate, intToFloatCurrency} from "../../../component/Utils";
import {ExpandMore} from "@mui/icons-material";
import {VOUCHER_PROVIDER_AMAZON} from "../../../component/Constants";
import {useHasScope} from "../../../../../config/globalConfig";

const VoucherDetailModal = ({
  open,
  handleClose,
  voucher,
}: VoucherDetailModalProps) => {
  const { t } = useTranslation(["salesmarketing"], { keyPrefix: "voucher" });

  const hasScope = useHasScope;
  const [isExpanded, setIsExpanded] = useState(true);
  const { getStatusLabelVoucher } = useStatusValuesVoucher();
  const linkToInvoice = "/finance/invoices/";
  const SCOPE_INVOICE = "SCOPE_SM_FINANCE_RECEIVABLE_VIEW_DETAIL";

  console.log({ voucher });

  const theme = useTheme();
  return (
    <Dialog
      scroll={"paper"}
      maxWidth={"lg"}
      disableEscapeKeyDown
      fullWidth={true}
      open={open}
      onClose={() => {
        return;
      }}
    >
      <DialogTitle>
        <Typography
          fontWeight={"bold"}
          color={"primary"}
          display={"inline-block"}
        >
          {t("inputDetailPageFields.details")}
        </Typography>
        <Button
          size={"medium"}
          variant="text"
          sx={{ marginLeft: "5px" }}
          component="label"
          onClick={() =>
            window.open(`/salesmarketing/subscriptionContractslist?voucherCode=${voucher.code}`)
            }
        >
          {t("inputDetailPageFields.goToSubscription")}
        </Button>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container rowSpacing={3} columnSpacing={3}>
          {
            <UserLegalEntitiesOrDealersInputGroup
              tenantId={voucher.tenantId}
              dealerId={voucher.tenantId}
              disabled
              hasCreatedDateFieldInsideVoucherDetail
              createdDateValue={voucher?.createdDate}
              itemWrappercolumns={6}
              itemColumns={6}
            />
          }
          <Grid item xs={3}>
            <TextField
                fullWidth
                label={t("inputDetailPageFields.lastModifiedDate")}
                margin="dense"
                variant="standard"
                inputProps={{ readOnly: true }}
                value={voucher.lastModifiedDate ? formatDate(voucher.lastModifiedDate) : ""}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.status")}
              value={getStatusLabelVoucher(voucher.status.toUpperCase())}
              margin="dense"
              variant="standard"
              inputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.voucherCode")}
              value={voucher.code}
              margin="dense"
              variant="standard"
              inputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.subscription")}
              value={voucher.subName}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.sku")}
              value={voucher.sku}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.price")}
              value={
                voucher?.price
                  ? intToFloatCurrency(voucher.price.toString())
                  : ""
              }
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.reservationDate")}
              value={voucher.reservationDate ? formatDate(voucher.reservationDate) : ""}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.bookingCode")}
              value={voucher.bookingCode}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.bpCode")}
              value={voucher.bpCode ?? ""}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.amazonBookingStatus")}
              value={voucher.amazonBookingStatus}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.invoice")}
              value={voucher?.invoiceCode ? voucher.invoiceCode : "-"}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
              InputProps={{
                endAdornment: (hasScope(SCOPE_INVOICE) && voucher?.invoiceDate && (
                    <Tooltip arrow title={t('inputUpdatePageFields.invoiceLink')}>
                      <Button
                              sx={{ color: theme.palette.accent.main, textTransform: "none", minWidth: "unset", whiteSpace: "nowrap" }}
                          onClick={() => {
                            window.open(linkToInvoice + voucher.invoiceId, "_blank");
                          }}
                          variant="text"
                      >
                        {t('inputUpdatePageFields.invoiceLink')}
                      </Button>
                    </Tooltip>
                    )
                )
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.invoiceDate")}
              value={voucher?.invoiceDate ?  formatDate(voucher.invoiceDate) : ""}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.provider")}
              value={voucher.provider}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.amazonEmail")}
              value={voucher.amazonEmail}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          {voucher?.provider &&
            voucher.provider === VOUCHER_PROVIDER_AMAZON && (
              <>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    name="isAmazonBusiness"
                    label={t("inputUpdatePageFields.isAmazonBusiness")}
                    value={t(
                      voucher.isAmazonBusiness === 1
                        ? "customerAssociated.yes"
                        : "customerAssociated.no"
                    )}
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    name="bpCode"
                    label={t("inputUpdatePageFields.bpCode")}
                    value={voucher.bpCode}
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    name="amazonInvoiceStatus"
                    label={t("inputUpdatePageFields.amazonInvoiceStatusLabel")}
                    value={
                      voucher.amazonInvoiceStatus
                        ? t(
                            "inputUpdatePageFields.amazonInvoiceStatus." +
                              voucher.amazonInvoiceStatus
                          )
                        : ""
                    }
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
              </>
            )}
          {voucher?.isAmazonBusiness === 1 && (
            <>
              <Grid item xs={12} sx={{ paddingTop: "50px" }}>
                <Accordion
                  defaultExpanded
                  onChange={(_e, expanded) => {
                    setIsExpanded(expanded);
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    {t("inputUpdatePageFields.customerDetails")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container item rowSpacing={3} columnSpacing={3}>
                      <Grid
                        container
                        item
                        xs={12}
                        rowSpacing={1}
                        columnSpacing={3}
                      >
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.vatNumber")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.vatNumber
                                ? voucher.amazonInvoiceData?.[0].vatNumber
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.businessName")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.businessName
                                ? voucher.amazonInvoiceData?.[0].businessName
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.address")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.address
                                ? voucher.amazonInvoiceData?.[0].address
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.city")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.city
                                ? voucher.amazonInvoiceData?.[0].city
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.country")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.country
                                ? voucher.amazonInvoiceData?.[0].country
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            label={t("inputUpdatePageFields.zipCode")}
                            value={
                              voucher?.amazonInvoiceData?.[0]?.zipCode
                                ? voucher.amazonInvoiceData?.[0].zipCode
                                : ""
                            }
                            margin="dense"
                            variant="standard"
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </>
          )}
          <Grid item xs={3}>
            <FormControlLabel
              sx={{ marginTop: "20px" }}
              control={<Checkbox checked={!!voucher.refundDate} />}
              label={t("inputDetailPageFields.refund")}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.refundDate")}
              value={
                voucher.refundDate ? formatDate(voucher.refundDate) : ""
              }
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t("inputDetailPageFields.note")}
              value={voucher.note}
              margin="dense"
              variant="standard"
              inputProps={{ readOnly: true }}
            ></TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ backgroundColor: theme.palette.neutral.main }}>
        <Button color={"accent"} onClick={() => handleClose()}>
          {t("inputDetailPageFields.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoucherDetailModal;
